module.exports = __webpack_public_path__ + "img/mrBts_test_001_BS.80fa7117.jpg";